<template>
  <svg
    :height="radius * 2"
    :width="radius * 2"
  >
    <text
      x="50%"
      y="50%"
      fill="white"
      :font-size="24"
      style="font-weight:bold;"
      dominant-baseline="middle"
      text-anchor="middle"
    >
      {{progress}}%
    </text>
    <circle
      stroke="#92d5f4"
      :stroke-width="stroke - 1"
      fill="transparent"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
    />
    <circle
      stroke="white"
      :stroke-dasharray="circumference + ' ' + circumference"
      :style="{ strokeDashoffset: strokeDashoffset }"
      :stroke-width="stroke"
      fill="transparent"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
    />
  </svg>
</template>

<script>
  export default {
    name: 'StatCircle',
    props: {
      radius: Number,
      progress: Number,
      stroke: Number
    },
    data() {
      const normalizedRadius = this.radius - this.stroke * 2;
      const circumference = normalizedRadius * 2 * Math.PI;

      return {
        normalizedRadius,
        circumference
      };
    },
    computed: {
      strokeDashoffset() {
        return this.circumference + (this.progress / 100 * this.circumference);
      }
    },
  }
</script>
